import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CircularProgress from '@mui/material/CircularProgress';

function ExecutiveCollection() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');


    const { isAuthenticated, companyId, permissions, token, logout } = useAuth();
    const [loading, setLoading] = useState(false);

    const [totalamt, setTotalamt] = useState(0);
    const [totalpaid, setTotalpaid] = useState(0);
    const [totalbalance, setTotalbalance] = useState(0);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        fetchCustomerData();
        fetchsalesman();
    }, [isAuthenticated, companyId, token, logout]);


    useEffect(() => {
        // Calculate totals
        let totalamt = 0;
        let totalpaid = 0;
        let totalbal = 0;


        dataItem.forEach(item => {
            totalamt += item.billAmount;
            totalpaid += item.paidAmount;
            totalbal += item.balanceAmount;
        });

        setTotalamt(totalamt);
        setTotalpaid(totalpaid);
        setTotalbalance(totalbal);
    }, [dataItem]);

    // Handle customer selection
    const handleCustomerSelect = (selectedOption) => {
        setSelectedCustomer(selectedOption);
        const customerId = selectedOption ? selectedOption.value : '';
        setCustomer(customerId);
        setDataItem([])
    };

    const [executiveOptions, setexecutiveOptions] = useState([]);
    const [selectedExecutive, setselectedExecutive] = useState(null);
    const [executiveId, setExecutive] = useState('0');
    //FOR GET Customer  Details FROM API
    const fetchsalesman = () => {
        fetchData('SalesManApi', `/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                // Transform the data into the format that react-select expects (label and value)
                const options = data.map((Salesman) => ({
                    label: Salesman.Name,
                    value: Salesman.Id,
                }));
                setexecutiveOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching customer data:', error);
            });
    };

    const handleExecutiveSelect = (selectedOption) => {
        setselectedExecutive(selectedOption);  // Set the selected option as state
        const executiveId = selectedOption ? selectedOption.value : '';  // Extract executiveId from the selected option
        setExecutive(executiveId);  // Set executiveId state
        setDataItem([]);  // Reset any related data
    };


    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerId, setCustomer] = useState('0');

    //FOR GET Customer  Details FROM API
    const fetchCustomerData = () => {
        fetchData('ReportApi', `/Customer/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                // Transform the data into the format that react-select expects (label and value)
                const options = data.map((customer) => ({
                    label: customer.Name,
                    value: customer.Id,
                }));
                setCustomerOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching customer data:', error);
            });
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };


    const getFormattedStartDate = () => {
        const today = new Date();
        let year = today.getFullYear();

        if (today.getMonth() + 1 > 3) {
            // If the current month is greater than 3, use the current year
            return `${year}-04-01`;
        } else {
            // If the current month is 3 or less, use the previous year
            return `${year - 1}-04-01`;
        }
    };


    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setFromDate(selectedDate);
    };

    // Similar function for toDate
    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const fetchTableData = async () => {
        if (hasReadReportPermission) {
            setDataItem([])
            setLoading(true);

            try {
                const response = await fetchData('ReportApi', `/${fromDate}/${toDate}/${companyId}/${executiveId}/${customerId}`, token);
                if (response.responseCode === '1111') {
                    setDataItem(response.response_data);

                }
            } catch (error) {
                console.error('Error fetching Collection Details:', error);
            }
            finally {
                setLoading(false); // Hide loading screen
            };
        }
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const handleExportExcel = () => {
        const excelData = [];
        const headerCaption = [`Collection Report `];
        excelData.push(headerCaption);
        const headerRow = ['Customer', 'Executive', 'Bill Date', 'Bill Number', 'Bill Amount', 'Paid Amount', 'Balance Amount', 'Due Days'];
        excelData.push(headerRow);
        filteredDataItem.forEach((rowData, index) => {
            const dataRow = [];
            dataRow.push(rowData.customerName, rowData.executiveName, formatDate(rowData.billDate), rowData.billNumber, parseFloat(rowData.billAmount.toFixed(2)), parseFloat(rowData.paidAmount.toFixed(2)), parseFloat(rowData.balanceAmount.toFixed(2)), rowData.duedays);
            excelData.push(dataRow);
        });
        //, rowData.PGCategoryName
        // Add total row
        const totalRow = ['Total', '', '', '', totalamt, totalpaid, totalbalance];
        excelData.push(totalRow);
        const ws = XLSX.utils.aoa_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Collection Report');
        XLSX.writeFile(wb, 'Collection Report.xlsx');
    };


    return (
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ maxWidth: '97%' }}>

            {loading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999
                }}>
                    <div>
                        <CircularProgress style={{ color: 'white' }} />
                        <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                    </div>
                </div>
            )}
            <div style={{ width: '100%', marginBottom: '2', display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
                <h5 style={{ flexGrow: 1, color: 'linkColor', fontFamily: 'Times New Roman', whiteSpace: 'nowrap', marginRight: '8px', fontWeight: 'bolder', marginTop: '-5px', fontWeight: 'bolder' }}>
                    COLLECTION SUMMARY
                </h5>

                <div className="w-1/6 mr-2">
                    <label style={{ display: 'block', color: 'black', fontSize: '12px', marginBottom: '2' }} htmlFor="party">
                        CUSTOMER
                        <span style={{ color: 'red' }}>*</span>
                    </label>
                    <Select
                        options={customerOptions}
                        value={selectedCustomer}
                        onChange={handleCustomerSelect}
                        placeholder="Select a customer"
                        style={{ width: '100%', maxWidth: '250px' }} />
                </div>
                <div className="w-1/6 mr-2">
                    <label style={{ display: 'block', color: 'black', fontSize: '12px', marginBottom: '2' }} htmlFor="party">
                        Executive
                        <span style={{ color: 'red' }}>*</span>
                    </label>
                    <Select
                        options={executiveOptions}
                        value={selectedExecutive}
                        onChange={handleExecutiveSelect}
                        placeholder="Select an executive"
                        style={{ width: '100%', maxWidth: '250px' }}
                    />
                </div>


                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label style={{ display: 'block', color: 'black', fontSize: '12px', marginBottom: '2' }} htmlFor="fromDate">
                        FROM DATE
                    </label>
                    <input
                        className="shadow appearance-none  rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label style={{ display: 'block', color: 'black', fontSize: '12px', marginBottom: '2' }} htmlFor="toDate">
                        TO DATE
                    </label>
                    <input
                        className="shadow appearance-none  rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>


                <Button
                    style={{
                        background: 'linear-gradient(to right, #C7FFD8,#C7FFD8)',
                        borderRadius: '50px',
                        padding: '10px 20px',
                        color: '#0F0F0F',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '35px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginLeft: '10px',
                        marginTop: '15px'
                    }}
                    onClick={fetchTableData}
                    className="linkcolor"
                >
                    Refresh
                </Button>

                <Button
                    style={{
                        background: 'linear-gradient(to right, #98DED9,#98DED9)',
                        borderRadius: '50px',
                        padding: '10px 20px',
                        color: '#0F0F0F',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '35px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginLeft: '10px',
                        marginTop: '15px'
                    }}
                    onClick={handleExportExcel}
                    className="linkcolor"
                >
                    Excel
                </Button>

            </div>


            <div className='w-full mb-5 flex' style={{ maxHeight: '490px', overflowY: 'auto', marginTop: '5px' }}>

                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#705C53', Width: '2500px' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', color: 'whitesmoke', padding: '5px' }}>Customer Name</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', color: 'whitesmoke', padding: '5px' }}>Executive</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', color: 'whitesmoke', padding: '5px' }}>Bill Date</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', color: 'whitesmoke', padding: '5px' }}>Bill Number</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', color: 'whitesmoke', textAlign: 'right', padding: '5px' }}>Bill Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', color: 'whitesmoke', textAlign: 'right', padding: '5px' }}>Paid Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', color: 'whitesmoke', textAlign: 'right', padding: '5px' }}>Balance Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontSize: '16px', color: 'whitesmoke', textAlign: 'right', padding: '5px' }}>Due Days</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody sx={{ backgroundColor: '#F5F5F7' }}>
                            {filteredDataItem.map((data, index) => (
                                <TableRow
                                    key={data.id}
                                    className={'highlighted-row'}
                                    sx={{
                                        padding: '5px',
                                        backgroundColor: 'transparent',

                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.customerName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.executiveName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{formatDate(data.billDate)} </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.billNumber}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.billAmount}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.paidAmount}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.balanceAmount}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', textAlign: 'right' }}>{data.duedays}</TableCell>
                                </TableRow>
                            ))}

                            <TableRow
                                className={'highlighted-row'}
                                sx={{
                                    padding: '5px',
                                    backgroundColor: '#AB886D',

                                }}
                            >

                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px', fontSize: '14px', textAlign: 'right' }}>Total</TableCell>
                                <TableCell colSpan={3} />
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '14px', textAlign: 'right' }}>{totalamt}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '14px', textAlign: 'right' }}>{totalpaid}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '14px', textAlign: 'right' }}>{totalbalance}</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '14px', textAlign: 'right' }}></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>



            </div>
        </div>
    );
}

export default ExecutiveCollection;
